import { UserTaskWasUpdatedNotification } from "#/store/types";
import { constructURLToTask } from "#/util";
import React from "react";
import style from "./index.module.scss";
import ItemWrapper from "./ItemWrapper";
import { DerivedNotificationItemProps } from "./types";

const TaskWasUpdatedNotification = React.forwardRef(
  (props: DerivedNotificationItemProps<UserTaskWasUpdatedNotification>, ref: React.Ref<any>) => (
    <ItemWrapper
      ref={ref}
      onClick={() => {
        props.push(constructURLToTask(props.notification.task_model));
      }}
      notification={props.baseNotification}
    >
      <span className={style["notification-menu-item__text"]}>
        Содержание задачи {`"${props.notification.task_model.name}"`} было изменено
      </span>
    </ItemWrapper>
  ),
);

export default TaskWasUpdatedNotification;
